<div class="light-blue-text otsikko">Lemonaid-mobiilisovellusten käyttäjät</div>

@if (lataa()) {
  <div class="lataus"><mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner></div>
} @else if (vastaus()) {
  <div class="selite">Viimeiset 6 kuukautta (alkaen {{ muotoilePaiva(vastaus().alkaenIso) }}). Haettu {{ muotoilePaivaJaAika(vastaus().haettuIso) }}. Mobiilikirjautumisia {{ vastaus().kirjautumisiaYhteensa }} kpl. Käyttäjä lasketaan sovellukseen viimeisimmän kirjautumisensa perusteella. Kirjanpitäjien emuloinnit eivät ole mukana.</div>

  <div class="alustat">
    @for (alusta of alustat(); track alusta.nimi) {
      <div class="alusta">
        <div class="alusta-otsikko">{{ alusta.nimi }}</div>
        <div class="luvut">
          <div class="luku">
            <div class="luku-arvo">{{ alusta.kayttajat.kayttajia }}</div>
            <div>käyttäjää</div>
          </div>
          <div class="luku">
            <div class="luku-arvo">{{ alusta.kayttajat.flutter }}</div>
            <div>Flutter ({{ osuus(alusta.kayttajat.flutter, alusta.kayttajat.kayttajia) }})</div>
          </div>
          <div class="luku">
            <div class="luku-arvo">{{ alusta.kayttajat.vanha }}</div>
            <div>vanha ({{ osuus(alusta.kayttajat.vanha, alusta.kayttajat.kayttajia) }})</div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="donitsit">
    <div class="donitsi"><canvas #iosCanvas></canvas></div>
    <div class="donitsi"><canvas #androidCanvas></canvas></div>
  </div>

  <div class="kaavio-otsikko">Aktiiviset käyttäjät viikoittain</div>
  <div class="viikot"><canvas #viikotCanvas></canvas></div>

  <div class="kaavio-otsikko">Vanhan sovelluksen versiot</div>
  <div class="versiot"><canvas #versiotCanvas></canvas></div>

  <div class="taulukot">
    @for (alusta of alustat(); track alusta.nimi) {
      <div>
        <div class="kaavio-otsikko">{{ alusta.nimi }}: laitteet</div>
        <table class="jakauma">
          @for (rivi of alusta.laitteet; track rivi.arvo) {
            <tr>
              <td>{{ rivi.arvo }}</td>
              <td class="maara">{{ rivi.kayttajia }}</td>
            </tr>
          }
        </table>
      </div>
      <div>
        <div class="kaavio-otsikko">{{ alusta.nimi }}: käyttöjärjestelmät</div>
        <table class="jakauma">
          @for (rivi of alusta.kayttojarjestelmat; track rivi.arvo) {
            <tr>
              <td>{{ rivi.arvo }}</td>
              <td class="maara">{{ rivi.kayttajia }}</td>
            </tr>
          }
        </table>
      </div>
    }
  </div>

  <ul class="rajoitukset">
    <li>Flutter-sovellus lähettää aina version "flutter/0.1", joten Flutter-versioita ei voi erotella toisistaan.</li>
    <li>Flutter-sovellus kertoo laitteeksi vain "iPhone" tai "Android", joten laitemallit näkyvät vain vanhan sovelluksen käyttäjiltä.</li>
    <li>Flutter-sovelluksen Android-käyttöjärjestelmätieto on Linux-ytimen versio, ei Android-versio.</li>
  </ul>
}
